import { useAppSelector } from "../../hooks";

export const useIsMobile = () => useAppSelector(state => state.device.isMobile);
